import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {TextRow, RoundShape} from 'react-placeholder/lib/placeholders';
import ReactPlaceholder from 'react-placeholder';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Fido from '../../utils/Fido';
import Constants from "../../utils/Constants";
import PaddedLayout from '../../components/PaddedLayout.js';
import FullscreenMessage from '../../components/FullscreenMessage';
import UserEngagementTable from "../components/UserEngagementTable";
import FilterSelect from "../../components/FilterSelect";

import {
	withStyles,
	Paper,
	Grid
} from '@material-ui/core';

const styles = theme => ({
	root: {
		[theme.breakpoints.down('lg')]: {
			paddingRight: theme.spacing(1.25)
		},

		[theme.breakpoints.up('xs')]: {
			paddingLeft: 10
		},

		[theme.breakpoints.up('sm')]: {
			paddingLeft: 0
		}
	},

	paddedLayout: {
		paddingBottom: 32,

		[theme.breakpoints.up('sm')]: {
			width: "95%",
		},

		[theme.breakpoints.up('lg')]: {
			width: "95%",
		},
	},

	filterGrid: {
		padding: theme.spacing(2),
		paddingLeft: `${theme.spacing(1)}px !important`
	}
});

const placeholderColor = Constants.COLORS.PLACEHOLDER_BG;
const tablePlaceHolder = (
	<div style={{padding: 15}}>
		<div style={{display: "flex"}}>
			<div style={{marginRight: 10}}>
				<RoundShape color={placeholderColor} style={{height: 48, width: 48}} />
			</div>
			<div style={{flex: 1, margin: "auto"}}>
				<TextRow color={placeholderColor} style={{marginTop: 0}} />
			</div>
			<div style={{flex: 1, paddingLeft: 5, margin: "auto"}}>
				<TextRow color={placeholderColor} style={{marginTop: 0}} />
			</div>
			<div style={{flex: 1, paddingLeft: 5, margin: "auto"}}>
				<TextRow color={placeholderColor} style={{marginTop: 0}} />
			</div>
		</div>
		<div style={{display: "flex", marginTop: 15}}>
			<div style={{marginRight: 10}}>
				<RoundShape color={placeholderColor} style={{height: 48, width: 48}} />
			</div>
			<div style={{flex: 1, margin: "auto"}}>
				<TextRow color={placeholderColor} style={{marginTop: 0}} />
			</div>
			<div style={{flex: 1, paddingLeft: 5, margin: "auto"}}>
				<TextRow color={placeholderColor} style={{marginTop: 0}} />
			</div>
			<div style={{flex: 1, paddingLeft: 5, margin: "auto"}}>
				<TextRow color={placeholderColor} style={{marginTop: 0}} />
			</div>
		</div>
	</div>
);

class UserEngagementReport extends Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			sortDir: "desc",
			sortBy: "activityCount",
			usersEngagement: null,
			fidoError: false,
			previousDays: [30]
		};

		this.fido = new Fido();
		this.sortHandler = this.sortHandler.bind(this);
		this.filterChanged = this.filterChanged.bind(this);
	}

	componentDidMount() {
		this.props.updateHeader({
			primary: false,
			title: 'User Engagement'
		});

		this.fetchData({
			query: {
				sortBy: this.state.sortBy,
				sortDir: this.state.sortDir,
				previousDays: this.state.previousDays[0]
			}
		});
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.sortBy !== prevState.sortBy || this.state.sortDir !== prevState.sortDir) {
			this.fetchData({
				query: {
					sortBy: this.state.sortBy,
					sortDir: this.state.sortDir,
					previousDays: this.state.previousDays[0]
				}
			});
		}
	}

	fetchData(opts) {
		this.fido.fetch("/reports/engagement", opts)
			.then((data) => {
				if (data) {
					// TEMP
					//data = userEngagementData;
					delete data.previousDays;
					this.setState(data);
				}
			})
			// TODO: probably only want to show some errors as snackbars
			.catch(error => {
				this.setState({fidoError: true});
				return this.props.showSnackbar(error.message);
			});
	}

	componentWillUnmount() {
		this.fido.dropIt();
		this.props.resetHeader();
	}

	sortHandler(event, property) {
		let sortDir = "asc";

		if (this.state.sortBy === property) {
			sortDir = this.state.sortDir === "desc" ? "asc" : "desc";
		}

		this.setState({sortBy: property, sortDir: sortDir});
	}

	filterChanged(selected) {
		if (JSON.stringify(this.state.previousDays) !== JSON.stringify(selected.previousDays)) {
			this.setState({
				usersEngagement: null,
				previousDays: selected.previousDays
			}, () => {
				this.fetchData({
					query: {
						sortBy: this.state.sortBy,
						sortDir: this.state.sortDir,
						previousDays: this.state.previousDays[0]
					}
				});
			});
		}
	}

	render() {
		let {classes} = this.props,
			{usersEngagement, sortBy, sortDir, previousDays} = this.state;

		return (
			<PaddedLayout
				isLarge
				noTopPad
				className={classes.paddedLayout}>
				<Grid
					container
					className={classes.filterGrid}
					justify={/*isXs ? "center" : */"flex-start"}>
					<Grid item>
						<FilterSelect
							singleSelect
							name="previousDays"
							options={Constants.REPORT.DAYS}
							defaultSelections={previousDays}
							menuTitle={`${previousDays[0]} Days`}
							handleUpdate={this.filterChanged}
							startIcon={<FontAwesomeIcon className={classes.clock} icon={["far", "clock"]} />} />
					</Grid>
				</Grid>
				{usersEngagement ?
					usersEngagement.length ?
						<Paper className={classes.root}>
							<UserEngagementTable
								sortDir={sortDir}
								sortBy={sortBy}
								users={usersEngagement}
								sortHandler={this.sortHandler} />
						</Paper>
						: <FullscreenMessage message="No Results" />
					: <Paper className={classes.root}>
						<ReactPlaceholder
							ready={false}
							customPlaceholder={tablePlaceHolder}
							showLoadingAnimation={!this.state.fidoError}>
							<span></span>
						</ReactPlaceholder>
					</Paper>
				}
			</PaddedLayout>
		);
	}
}

UserEngagementReport.propTypes = {
	classes: PropTypes.object.isRequired,
	resetHeader: PropTypes.func.isRequired,
	updateHeader: PropTypes.func.isRequired,
	showSnackbar: PropTypes.func,
	location: PropTypes.object
};

export default withStyles(styles)(UserEngagementReport);